document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  const form = productForm.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const meta = JSON.parse(
    document.getElementById('product-meta')?.textContent || '{}'
  ).metafields || {};

  // Inject immediately — no race with Dawn's submit handler
  Object.entries(meta)
    .filter(([_, v]) => v)
    .forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[_${key}]`;
      input.value = value;
      form.appendChild(input);
    });
});